import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";

const SiteDataTable = ({ customerId }) => {
    const dataTableRef = useRef(null);
    const [search, setSearch] = useState("");

    const renderRowButton = (site) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!site.can && site.can.view === true && (
                        <a className="text-primary cursor-pointer" href={route('customer.site.show', {site: site.id, customer: customerId}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"mh-100 border-0"} noPadding={!!customerId}>
                <div className={"row m-0 mb-4 p-0 d-flex justify-content-lg-between"}>
                    <div className="col-12 col-lg-6 m-0 mb-3 mb-lg-0 p-0 pl-lg-2 order-lg-2">
                        <div className={"d-flex justify-content-between justify-content-lg-end align-items-center"}>
                            {can('create', 'site') && (
                                <Button
                                    href={route('customer.site.create', {customer: customerId}).toString()}
                                    label={"Create Site"}
                                    icon={"far fa-plus-circle"}
                                    classes={"ml-4 btn btn-eh-lilac px-3 m-0"}
                                />
                            )}
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 m-0 p-0 pr-lg-2 order-lg-1 d-flex justify-content-start align-items-center">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.customer.site.data-table', {customer: customerId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="sites" />}
                                fieldsToExclude={[
                                    'id',
                                    'contact_first_name',
                                    'contact_last_name',
                                    'contact_telephone_number_link',
                                    'contact_mobile_number',
                                    'contact_mobile_number_link',
                                    'contact_email',
                                    'contact_email_link',
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    address_line:               "Address",
                                    contact_name:               "Main Contact",
                                    contact_telephone_number:   "Telephone Number",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'address_line'}
                                defaultOrderByDirection={'asc'}
                                params={{
                                    searchTerm: search,
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'contact_telephone_number':
                                            if (!!row.contact_telephone_number_link) {
                                                return (
                                                    <a href={row.contact_telephone_number_link} className="text-eh-off-black text-underline">{row.contact_telephone_number}</a>
                                                );
                                            }
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default SiteDataTable;

const target = document.getElementById('sites-datatable');
if (target) {
    const {
        customerId = null,
    } = target.dataset;
    ReactDOM.render(<SiteDataTable customerId={customerId} />, target);
}
